import { GETDEPARTMENTLIST_SUCCESS, GETDEPARTMENTLIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getdepatmentlistReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETDEPARTMENTLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETDEPARTMENTLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getdepatmentlistReducer;



